export default "__VITE_ASSET__Dz7qX$jY__"